import React, { createContext, useState, useEffect } from "react";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  // Step 1: Load cart from localStorage when the app starts
  const [cart, setCart] = useState(() => {
    try {
      const savedCart = localStorage.getItem("cart");
      return savedCart ? JSON.parse(savedCart) : [];
    } catch (err) {
      console.error("Error loading cart from localStorage", err);
      return [];
    }
  });

  // Step 2: Save cart to localStorage whenever it changes
  useEffect(() => {
    try {
      localStorage.setItem("cart", JSON.stringify(cart));
    } catch (err) {
      console.error("Error saving cart to localStorage", err);
    }
  }, [cart]);

  const addToCart = (product) => {
    setCart((prevCart) => {
      const existingItem = prevCart.find((item) => item.id === product.id);
      if (existingItem) {
        return prevCart.map((item) =>
          item.id === product.id
            ? { ...item, qty: item.qty + 1 }
            : item
        );
      }
      return [...prevCart, { ...product, qty: 1 }];
    });
  };

  const increaseQty = (id) => {
    setCart((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, qty: item.qty + 1 } : item
      )
    );
  };

  const decreaseQty = (id) => {
    setCart((prev) =>
      prev
        .map((item) =>
          item.id === id
            ? { ...item, qty: item.qty - 1 }
            : item
        )
        .filter((item) => item.qty > 0) // Remove item if qty becomes 0
    );
  };

  const removeItem = (id) => {
    setCart((prev) => prev.filter((item) => item.id !== id));
  };

  const setQty = (product, newQty) => {
    const qtyNum = parseInt(newQty, 10) || 0;
    setCart((prev) => {
      const existingItem = prev.find((item) => item.id === product.id);
      if (qtyNum <= 0) {
        return prev.filter((item) => item.id !== product.id);
      }
      if (existingItem) {
        return prev.map((item) =>
          item.id === product.id ? { ...item, qty: qtyNum } : item
        );
      }
      return [...prev, { ...product, qty: qtyNum }];
    });
  };

  const clearCart = () => {
    setCart([]);
    localStorage.removeItem("cart"); // Clear from storage after order
  };

  const [storeTheme, setStoreTheme] = useState(() => {
    return localStorage.getItem("store_ui_theme") || "theme1";
  });

  return (
    <CartContext.Provider
      value={{
        cart,
        setCart,
        addToCart,
        increaseQty,
        decreaseQty,
        setQty,
        removeItem,
        clearCart,
        storeTheme,
        setStoreTheme,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};